export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11188.9a054d35.jpg";